import React from 'react';
import {
  Button,
  Row,
  Glyphicon,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

import './ApproveButton.css';

const APPROVED = 'approved';
const UNAPPROVED = 'unapproved';

const propTypes = exact({
  forApproval: PropTypes.bool.isRequired,
  timesheet: PropTypes.object.isRequired,
  disableApproveUnapproveButton: PropTypes.bool.isRequired,
  disableApproveUnapproveButtonForId: PropTypes.string,
  dispatchChangeApprovalState: PropTypes.func.isRequired,
  dispatchShowGuaranteedTimeModal: PropTypes.func.isRequired,
  supervisorId: PropTypes.number.isRequired,

  approvable: PropTypes.bool.isRequired,
  missingTimesheets: PropTypes.array.isRequired,
  unworkedPerDiems: PropTypes.array.isRequired,
  pendingPerDiems: PropTypes.array.isRequired,
});


const ApproveButton = (props) => {
  const {
    forApproval,
    timesheet,
    dispatchChangeApprovalState,
    dispatchShowGuaranteedTimeModal,
    disableApproveUnapproveButton,
    disableApproveUnapproveButtonForId,
    supervisorId,
    approvable,
    missingTimesheets,
    unworkedPerDiems,
    pendingPerDiems,
  } = props;

  const hasMissingTimesheets = !!missingTimesheets.length;
  const hasUnworkedPerDiems = !!unworkedPerDiems.length;
  const hasPendingPerDiems = !!pendingPerDiems.length;
  const { promptForGuaranteePay, firstWeekApprovalRequired } = timesheet;

  const displayDates = (label, dates, id) => {
    return (
      <div>
        <strong>
          {label}
          {dates.map((date) => {
            const rowKey = `${id}${date.display}`;
            return (
              <div key={rowKey}>
                <span>{date.display}</span>
              </div>
            );
          })}
        </strong>
      </div>
    );
  };

  const displayErrorMessage = (label) => {
    return (
      <div>
        <strong>
          {label}
        </strong>
      </div>
    );
  };

  const tooltip = (
    <Tooltip id="tooltip">
      {hasMissingTimesheets && displayDates('Missing Timesheets', missingTimesheets, timesheet.id)}
      {hasUnworkedPerDiems && displayDates('Unworked Per Diems', unworkedPerDiems, timesheet.id)}
      {hasPendingPerDiems && displayDates('Pending Per Diems', pendingPerDiems, timesheet.id)}
      {firstWeekApprovalRequired && displayErrorMessage('First pay period week is unapproved')}
    </Tooltip>
  );

  const handleDisplayIcon = () => {
    if (!approvable && timesheet.state === UNAPPROVED) {
      return 'exclamation-sign';
    } if (forApproval) {
      return 'thumbs-up';
    }
    return 'thumbs-down';
  };

  const MaybeOverlayTrigger = (triggerProps) => {
    if (!approvable && timesheet.state === UNAPPROVED) {
      return (
        <OverlayTrigger animation={false} placement="top" overlay={tooltip}>
          {triggerProps.children}
        </OverlayTrigger>
      );
    }

    return (
      <React.Fragment>
        {triggerProps.children}
      </React.Fragment>
    );
  };

  const handleChangeApprovalStateWithoutEventPropogation = (e) => {
    /* Can't approve if not all timesheets for a week are in */
    if ((approvable && timesheet.state === UNAPPROVED) || timesheet.state === APPROVED) {
    // this is related to the button on top of a selectable row.
      const { guaranteed_eligible: guaranteedEligible } = timesheet.user;
      e.stopPropagation();
      if (forApproval && promptForGuaranteePay && guaranteedEligible) {
        dispatchShowGuaranteedTimeModal(timesheet);
      } else {
        dispatchChangeApprovalState(timesheet, forApproval, 0, supervisorId);
      }
    }
  };

  const isBeingUpdated = disableApproveUnapproveButtonForId === timesheet.id;

  const selectButton = () => {
    if (isBeingUpdated) {
      return (
        <Button
          className="btn btn-md btn-default"
        >
          <Glyphicon glyph="refresh" className="glyphicon glyphicon-refresh glyphicon-spin" />
        </Button>
      );
    } if (disableApproveUnapproveButton) {
      return (
        <Button
          className="btn btn-md btn-default"
        >
          <Glyphicon glyph={handleDisplayIcon()} />
        </Button>
      );
    }


    return (
      <MaybeOverlayTrigger>
        <Button
          className="btn btn-md btn-default"
          onClick={(e) => { return handleChangeApprovalStateWithoutEventPropogation(e); }}
        >
          <Glyphicon glyph={handleDisplayIcon()} />
        </Button>
      </MaybeOverlayTrigger>
    );
  };

  return (

    <Row className="approveButton-button">
      {selectButton()}
    </Row>
  );
};

ApproveButton.propTypes = propTypes;

export default ApproveButton;
